import { c as _c } from "react/compiler-runtime";
import { EmblaCarouselType } from "embla-carousel";
import React, { useCallback, useEffect, useState } from "react";
export const useDotButton = (emblaApi, onButtonClick) => {
  const $ = _c(13);
  const [selectedIndex, setSelectedIndex] = useState(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [scrollSnaps, setScrollSnaps] = useState(t0);
  let t1;
  if ($[1] !== emblaApi || $[2] !== onButtonClick) {
    t1 = index => {
      if (!emblaApi) {
        return;
      }
      emblaApi.scrollTo(index);
      if (onButtonClick) {
        onButtonClick(emblaApi);
      }
    };
    $[1] = emblaApi;
    $[2] = onButtonClick;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onDotButtonClick = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = emblaApi_0 => {
      setScrollSnaps(emblaApi_0.scrollSnapList());
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onInit = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = emblaApi_1 => {
      setSelectedIndex(emblaApi_1.selectedScrollSnap());
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const onSelect = t3;
  let t4;
  let t5;
  if ($[6] !== emblaApi) {
    t4 = () => {
      if (!emblaApi) {
        return;
      }
      onInit(emblaApi);
      onSelect(emblaApi);
      emblaApi.on("reInit", onInit).on("reInit", onSelect).on("select", onSelect);
    };
    t5 = [emblaApi, onInit, onSelect];
    $[6] = emblaApi;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  let t6;
  if ($[9] !== onDotButtonClick || $[10] !== scrollSnaps || $[11] !== selectedIndex) {
    t6 = {
      selectedIndex,
      scrollSnaps,
      onDotButtonClick
    };
    $[9] = onDotButtonClick;
    $[10] = scrollSnaps;
    $[11] = selectedIndex;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export const DotButton = props => {
  const $ = _c(6);
  let children;
  let restProps;
  if ($[0] !== props) {
    ({
      children,
      ...restProps
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = restProps;
  } else {
    children = $[1];
    restProps = $[2];
  }
  let t0;
  if ($[3] !== children || $[4] !== restProps) {
    t0 = <button type="button" {...restProps}>{children}</button>;
    $[3] = children;
    $[4] = restProps;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
};